import { render } from "./CloseModal.vue?vue&type=template&id=07bcef46"
import script from "./CloseModal.vue?vue&type=script&lang=js"
export * from "./CloseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__